import { createTheme } from "@mui/material";

//Button
const BUTTON_SHRINK_BY_VALUE = 0.98;

export const palette = {
  white: "#fff",
  offWhite: "#fcfcfc",
  grag: "#555555",
  darkGray: "#666666",
  lightGray: "#dddddd",
  offLightGray: "#e5e5e5",
  green: "#3e6bad",
  lightGreen: "#48a8a5",
  grayBorder: "#f1f1f1",
  /* for background*/
  bgGray: "#f9f9f9",
  /*for tshirt*/
  burgundy: "#501d36",
  cyan: "#2484BA",
  blue: {
    primary: "#074174",
    headings: "#12213B",
    buttonHover: "#095190",
    secondary: "#2484BA",
    secondaryButtonHover: "#2892cd",
  },
  black: {
    primary: "#000",
    headings: "#222",
    border: "#D9D9D9",
    uneditableText: "#666666",
    uneditableBackground: "#F8F9FC",
  },
  red: {
    error: "#D80D0D",
  },
  borderGradient: `linear-gradient(white, white) padding-box,
    linear-gradient(to right, rgba(84, 172, 222, 1), rgba(169, 84, 222, 1)) border-box`,
  borderGradientHover: `linear-gradient(white, white) padding-box,
    linear-gradient(to right, #CCDCE6, #DCCCE6) border-box`,
};
const tempTheme = createTheme();

export const theme = createTheme({
  typography: {
    fontFamily: "Apercu Pro",
    fontSize: 13,
    h2: {
      color: palette.blue.headings,
      fontFamily: "Apercu Pro",
      fontSize: "28px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "normal",
      [tempTheme.breakpoints.down("sm")]: {
        fontSize: "24px",
      },
    },
    body1: {
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      color: palette.blue.headings,
    },
    body2: {
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      color: palette.blue.headings,
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          padding: "8px 12px",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 400,
          lineHeight: "24px",
          border: `1px solid ${palette.black.border}`,
          margin: "1px",
          "&.Mui-disabled": {
            background: palette.black.uneditableBackground,
            color: palette.black.uneditableText,
            "&:hover": {
              boxShadow: "none",
              border: `1px solid ${palette.black.border}`,
            },
          },
          "&:hover": {
            boxShadow: "0px 0px 0px 2px rgba(36, 132, 186, 0.10)",
          },
          "&.Mui-focused": {
            border: `2px solid ${palette.blue.secondary}`,
            margin: "0px",
            "&>span": {
              //Prevent icon from shifting right
              marginRight: "-2px",
            },
          },
          "&.Mui-error": {
            border: `1px solid ${palette.red.error}`,
            margin: "1px",
            marginBottom: "4px",
            "&:hover, &.Mui-focused": {
              boxShadow: "0px 0px 0px 2px rgba(216, 13, 13, 0.10)",
            },
            "&>span": {
              marginRight: "0",
            },
          },
        },
        input: {
          padding: 0,
          paddingBottom: "1px",
          color: palette.black.headings,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          maxHeight: "unset",
          border: "none !important",
          fontSize: "14px",
          margin: "1px",

          "&>input": {
            padding: "4px 4px 6px 4px !important",
          },
          "&.Mui-focused": {
            border: `none`,
          },
          "&:hover": {
            boxShadow: `none`,
          },
          "&:active": {
            border: `none`,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontSize: 12,
          lineHeight: "16px",
          padding: "8px 12px",
        },
        sizeMedium: {
          fontSize: 16,
          lineHeight: "24px",
          padding: "12px 20px",
          "&:active": {
            transform: `scale(${BUTTON_SHRINK_BY_VALUE}, ${BUTTON_SHRINK_BY_VALUE})`,
          },
        },
        root: {
          borderRadius: 8,
          padding: 10,
          maxHeight: 48,
          backgroundColor: palette.blue.primary,
          color: palette.white,
          fontSize: 16,
          textTransform: "none",
          boxShadow: "none !important",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedPrimary: {
          backgroundColor: palette.blue.primary,
          color: palette.white,
          fontWeight: 600,

          "&:hover": {
            backgroundColor: palette.blue.buttonHover,
          },
          "&.Mui-disabled": {
            background: "#ddd",
            color: "#858585",
          },
        },
        containedSecondary: {
          backgroundColor: palette.blue.secondary,
          color: palette.white,
          padding: "8px 12px",
          maxHeight: 36,
          fontSize: 12,
          fontWeight: 500,
          maxWidth: "fit-content",

          "&:hover": {
            backgroundColor: palette.blue.secondaryButtonHover,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: `${palette.cyan} !important`,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Apercu Pro",
          fontSize: "14px",
          fontWeight: 400,
          color: palette.darkGray,
          lineHeight: "normal",
          "&.Mui-error": {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "150%",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeMedium: {
          width: "20px",
          height: "20px",
        },
      },
    },
  },
});
